export function dateFtt(fmt, date) {
  var o = {
    "M+": date.getMonth() + 1, //月份
    "d+": date.getDate(), //日
    "h+": date.getHours(), //小时
    "m+": date.getMinutes(), //分
    "s+": date.getSeconds(), //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    "S": date.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  for( var k in o )
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

export function getDiffTime(newDate, oldDate) {
  var difftime = (newDate - oldDate) / 1000; //计算时间差,并把毫秒转换成秒

  var days = parseInt(difftime / 86400); // 天  24*60*60*1000
  var hours = parseInt(difftime / 3600) - 24 * days;    // 小时 60*60 总小时数-过去的小时数=现在的小时数
  var minutes = parseInt(difftime % 3600 / 60); // 分钟 -(day*24) 以60秒为一整份 取余 剩下秒数 秒数/60 就是分钟数
  var seconds = parseInt(difftime % 60);  // 以60秒为一整份 取余 剩下秒数

  let string;
  if (days > 0) {
    string = days + "天" + hours + "时" + minutes + "分" + seconds + "秒"
  } else {
    string = hours + "时" + minutes + "分" + seconds + "秒"
  }
  return string
}

export function getDiffSecond(newDate, oldDate) {
  var difftime = (newDate - oldDate) / 1000;
  return parseInt(difftime)
}

export function stringIsNull(string) {
  if (typeof string === "string") {
    string = string.trim()
  }
  return string === undefined || string === null || string === ""
}

export function BooleanIsNull(string) {
  return string === undefined || string === null
}

// 根据当前年份将月日转换成年月日(02-01 => 2023-02-01)
export function monthToYear(paramDay) {
  // 当前日期  月
  var curMonth = getDateTime('month')
  var curYear = getDateTime('year')
  // 参数月份
  var paramMonth = paramDay.substring(1, 2)
  // 参数年份
  var paramYear;
  // 最终年月日
  var monthAndYear;
  // 对比参数的月份是否大于当前月份，大于则是前一年
  if (Number.parseInt(paramMonth) > Number.parseInt(curMonth)) {
    paramYear = Number.parseInt(curYear) - 1
  } else {
    paramYear = Number.parseInt(curYear)
  }
  monthAndYear = paramYear + "-" + paramDay
  return monthAndYear
}

// 获取当前日期
export function getDateTime(type) {
  var date = new Date();
  var hengGang = "-";
  var maoHao = ":";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var curDate = date.getDate();
  var curHours = date.getHours();
  var curMinutes = date.getMinutes();
  var curSeconds = date.getSeconds();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (curDate >= 0 && curDate <= 9) {
    curDate = "0" + curDate;
  }
  if (curHours >= 0 && curHours <= 9) {
    curHours = "0" + curHours;
  }
  if (curMinutes >= 0 && curMinutes <= 9) {
    curMinutes = "0" + curMinutes;
  }
  if (curSeconds >= 0 && curSeconds <= 9) {
    curSeconds = "0" + curSeconds;
  }
  var currentdate;
  if (type === "year") {
    currentdate = year;
    return currentdate;
  } else if (type === "month") {
    currentdate = month;
    return currentdate;
  } else if (type === "day") {
    currentdate = curDate;
    return currentdate;
  } else if (type === "yearAndMonth") {
    currentdate = year + hengGang + month;
    return currentdate;
  } else if (type === "yearAndMonthAndDay") {
    currentdate = year + hengGang + month + hengGang + curDate;
    return currentdate;
  } else if (type === "monthAndDay") {
    currentdate = month + hengGang + curDate;
    return currentdate;
  } else {
    currentdate = year + hengGang + month + hengGang + curDate + " " + curHours + maoHao + curMinutes + maoHao + curSeconds;
    return currentdate;
  }
  // var year = getDateTime('year');
  // console.log(year);  // 2021
  // var month = getDateTime('yearAndMonth');
  // console.log(month); // 2021-12
  // var date = getDateTime('');
  // console.log(date);  // 2021-12-03 09:00:00
}

// 判断类型为空或者underfined
export function isNullOrUnderfined(value) {
  let flag = false
  if (typeof (value) === 'undefined' ||
    !value) {
    flag = true
  }
  return flag
}

